import { deepCopy } from '../tools'

export default {
  props: ['dataSource'],
  computed: {
    isDisabled() {
      if (this.model.Disabled == undefined || this.model.Disabled == '') {
        return false
      }
      return this.evaluateDataExpression(this.model.Disabled)
    },
    isVisible() {
      if (this.model.Visible == undefined || this.model.Visible == '') {
        return true
      }

      if (typeof this.model.Visible == 'string') {
        return this.evaluateDataExpression(this.model.Visible)
      }
      return this.model.Visible
    },
    isReadonly() {
      if (typeof this.model.Readonly !== 'string' || `${this.model.Readonly}`.length <= 1) {
        return false
      }

      const expression = this.evaluateDataExpression(this.model.Readonly)
      if (typeof expression !== 'boolean') {
        return false
      }

      return expression
    },
    // Определения стиля input виджетов
    isRegular() {
      if (this.model.Style == undefined || this.model.Style == '') {
        return true
      }
      return this.model.Style == 'regular'
    },

    isSolo() {
      return this.model.Style == 'solo'
    },
    isFilled() {
      return this.model.Style == 'filled'
    },
    isOutlined() {
      return this.model.Style == 'outlined'
    }
  },
  methods: {
    /**
     * Метод возвращает результат выполненого выражения
     * @param {*} expression
     * @returns
     */
    evaluateDataExpression(expression) {
      if (this.isInEditorMode || !this.dataSource || !expression) {
        return expression
      }

      try {
        // создаем контекст для работы выражения, доступ к источнику данных, параметры роута и конфигурации приложения
        const dataSourceKeys = Object.keys(this.dataSource || {}).map((x) => `$${x}`)

        const dataSourceValues = deepCopy(Object.values(this.dataSource || {}))
        const routeValues = {
          query: deepCopy(this.$route.query || {}),
          params: deepCopy(this.$route.params || {})
        }
        const applicationConfigValues = deepCopy(this.$store.getters.getAppSettings)

        const args = dataSourceKeys.concat('$route', '$applicationConfig')
        const values = dataSourceValues.concat(routeValues, applicationConfigValues)
        const func = new Function(args, `return ${expression}`)

        return func(...values)
      } catch (ex) {
        console.error(`${this.$t('vuetifyWidgets.dataExpression.errorProcessingExpression')} ${this.model.$Type}`, ex)
      }
    },

    getExternalSourceField(field) {
      // field = ссылка на поле источника данных
      if (this.isInEditorMode || !field) {
        return field
      }

      if (!field.startsWith('$')) {
        // field - может быть одним из системных ключевых слов (они не начинаются з '$')
        if (!Object.values(serviceKeywords).includes(field)) {
          return field
        }

        // если виджет не внутри dataWidget
        if (this.dataSource === undefined) {
          return null
        }
        // если используется widget-list значение текущей строки лежит в dataSource.data и использовать нужно её, а не весь источник данных
        const ds = this.dataSource.parentDataSource !== undefined ? this.dataSource.data : this.dataSource
        return getDataSourceValueByServiceKeyword(ds, field)
      }

      if (field.startsWith('$applicationConfig')) {
        return this.getApplicationConfigValue(field)
      }

      // обрезаем первый символ - $
      const key = field.substring(1)
      // поле может содержать ссылку на поле vue.router
      if (key.substring(0, 5) === 'route') {
        return findRouterField({ params: { ...this.$router.currentRoute.params }, query: { ...this.$router.currentRoute.query } }, key.slice(6))
      }
      // выполняем поиск в data source
      if (this.dataSource) {
        return deepFind(this.dataSource, key)
      }

      return field
    },

    getDataSourceField(field) {
      // field = ссылка на поле источника данных
      if (!field || !field.startsWith('$')) {
        return field
      }

      if (field.startsWith('$applicationConfig')) {
        return this.getApplicationConfigValue(field)
      }

      if (!this.isInEditorMode && this.dataSource) {
        let key = field.substring(1)
        return deepFind(this.dataSource, key)
      }
      return field
    },

    getRouteField(field) {
      // field = ссылка на поле источника данных
      if (!this.isInEditorMode && field && field.startsWith('$')) {
        let key = field.substring(1)
        return findRouterField({ params: { ...this.$router.currentRoute.params }, query: { ...this.$router.currentRoute.query } }, key)
      }
      return field
    },

    setDataSourceField(field, value) {
      if (this.dataSource) {
        let key = field
        if (typeof key == 'string' && key.startsWith('$')) {
          key = key.substring(1)
        }

        let paths = key.split('.'),
          current = this.dataSource,
          i = 0

        for (; i < paths.length - 1; ++i) {
          if (current[paths[i]] == undefined) {
            return undefined
          }
          current = current[paths[i]]
        }

        // reconcile types of value in datasource and new value
        let targetType = typeof current[paths[i]]
        let sourceType = typeof value
        if (targetType != sourceType) {
          if (targetType == 'number') {
            value = Number(value)
            if (isNaN(value)) {
              value = 0
            }
          }
        }

        current[paths[i]] = value
      }
    },
    // Получение значения из model.Settings => $applicationConfig.Name
    getApplicationConfigValue(value) {
      let keys = value.replace('$', '').replace('applicationConfig.', '').split('.')
      let appConfigValue = this.$store.getters.getAppSettings
      keys.forEach((element) => {
        appConfigValue = appConfigValue[element]
      })
      if (!appConfigValue) {
        return value
      }
      return appConfigValue
    },

    evaluateExpression(value) {
      if (!value) {
        return value
      }

      const localeRegex = /\$t\((.*?)\)/gm
      // The substituted value will be contained in the result variable
      const localeresult = value.replace(localeRegex, (match, p1) => {
        let x = undefined
        return (x = this.$t(p1)) === undefined ? match : x
      })

      const regex = /\${(.*?)}/gm
      if (this.dataSource !== undefined || localeresult.includes('${applicationConfig')) {
        // The substituted value will be contained in the result variable
        const result = localeresult.replace(regex, (match, p1) => {
          if (p1.startsWith('applicationConfig')) {
            return this.getApplicationConfigValue(p1)
          }
          let x = undefined
          return (x = deepFind(this.dataSource, p1)) === undefined ? match : x
        })
        return result
      }
      return localeresult
    },

    evaluateClasses({ classes, hideOnMobile, hideOnTablet, hideOnPC }, ...additionalClasses) {
      if (this.isInEditorMode && this.$store.state.appModels.isHideUserClasses) {
        return [additionalClasses.join(' ')]
      }
      const parameters = [additionalClasses.join(' '), this.evaluateExpression(classes)]
      if (!this.isInEditorMode) {
        hideOnMobile && parameters.push('hide-on-mobile')
        hideOnTablet && parameters.push('hide-on-tablet')
        hideOnPC && parameters.push('hide-on-pc')
      }
      return parameters
    },
    evalColorExpression(modelColor) {
      const colorContent = this.evaluateExpression(modelColor)
      const defaultColorsObj = this.$vuetify.theme.defaults.light
      const appColorsObj = this.$store.state.appModels.model?.Settings?.Colors || {}
      const appColorPalette = Object.keys(defaultColorsObj).map((el) => {
        return { text: el, color: appColorsObj[el] || defaultColorsObj[el] }
      })
      const colorKey = appColorPalette.find((x) => {
        return x.text.toLowerCase() === colorContent.toLowerCase() || x.color.toLowerCase() === colorContent.toLowerCase()
      })

      if (!colorKey || !colorKey.color) {
        return colorContent
      }
      return colorKey.color
    }
  }
}

/**
 * Системные ключевые слова
 */
const serviceKeywords = {
  CONTEXT: 'Context'
}

function deepFind(obj, path) {
  let paths = path.split('.'),
    current = obj,
    i

  for (i = 0; i < paths.length; ++i) {
    if (current[paths[i]] == undefined) {
      return undefined
    }
    current = current[paths[i]]
  }
  return current
}

function findRouterField(router, key) {
  const { query, params } = router

  if (key.substring(0, 6) === 'params') {
    // slice обрезает 'params.' от ключа
    return deepFind(params, key.slice(7))
  }

  // slice обрезает 'query.' от ключа
  return deepFind(query, key.slice(6))
}

/**
 * Получить обработанное значение из источника данных по системному ключу
 * @param {*} dataSource
 * @param {*} key
 * @returns
 */
function getDataSourceValueByServiceKeyword(dataSource, key) {
  let value = null
  switch (key) {
    case serviceKeywords.CONTEXT:
      value = deepCopy(dataSource)
      break
    default:
      break
  }
  return value
}
